import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/Bbpslogo3.svg';

import GrowYourBussion from '../../Components/GrowYourBussion/GrowYourBussion';
import AboutPay2Mobile from '../../Components/AboutPay2Mobile';

import FooterContent from '../../Components/Footer/footer-content';
import DownloadPay2Mobile from '../../Components/DownloadPay2Mobile';
import bbpsLogo from '../../assets/images/BbpsLogo1.png';
import { ServiceBoxWrapper, Wrapper } from '../../Components/ServicesBox/style';
import { serviceType } from './constant';
import IconAEPS from '../../assets/images/IconAEPS';
import IconAadhayPay from '../../assets/images/IconAadhayPay';
import IconMobileRecharge from '../../assets/images/IconMobileRecharge';
import IconBillRecharge from '../../assets/images/IconBillRecharge';
import IconBroadband from '../../assets/images/IconBroadband';
import IconDTH from '../../assets/images/IconDTH';
import IconSendmoney from '../../assets/images/IconSendmoney';
import IconAddmoney from '../../assets/images/IconAddmoney';
import IconCredit from '../../assets/images/IconCredit';
import IconWater from '../../assets/images/IconWater';
import IconExploreMore from '../../assets/images/IconExploreMore';
import Back from '../../Components/UIbox/Back';
import { useContext } from 'react';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import { useEffect } from 'react';
import { useState } from 'react';
import { isEmpty } from '../../utils/common';

const ServiceList = () => {
	const iconMap = {
		IconAEPS: <IconAEPS />,
		IconAadhayPay: <IconAadhayPay />,
		IconMobileRecharge: <IconMobileRecharge />,
		IconBillRecharge: <IconBillRecharge />,
		IconBroadband: <IconBroadband />,
		IconDTH: <IconDTH />,
		IconSendmoney: <IconSendmoney />,
		IconAddmoney: <IconAddmoney />,
		IconCreditCard: <IconCredit />,
		IconWater: <IconWater />,
		IconExploreMore: <IconExploreMore />,
		IconBBPS: bbpsLogo,
	};

	const navigate = useNavigate();

	const { userDetails, apiPermission } = useContext(GlobleContaxt);
	
		useEffect(() => {
			if (isEmpty(userDetails?.userName) || apiPermission?.includes('BBPS')) return;
			navigate('/');
		
	}, [userDetails]);
	return (
		<>
			<div className="container">
				<div className="Home-page">
					<Wrapper className={`tab-content-wrapper m0 bbps`}>
						<>
							<ServiceBoxWrapper>
								<div className="header flex justify-between items-center">
									<Back url="/" />
									{/* <Back url="/bbps-services" /> */}
									<h2 className="m0">Our Services</h2>

									<div className="logo">
										<img src={logo} alt="bbps logo" />
									</div>
								</div>
								<div className="service-box-body">
									{/* <h2>Recharge & pay bills, book hotels, Bus, & flights tickets, and do a lot more.</h2> */}
									<h2>Bharat Connect Services</h2>
									<div className="service-box mainService flex" style={{ justifyContent: 'center' }}>
										{serviceType &&
											serviceType.map((val, i) => {
												console.log(val);
												return val.show === 'all' ? (
													<div key={i} className="serviceCard center" onClick={() => navigate(val.link, { state: val })}>
														<div>
															{typeof iconMap[val.icon] === 'string' ? <img src={bbpsLogo} alt={'bbpsLogo'} /> : iconMap?.[val.icon]}

															<h3>{val.title}</h3>
														</div>
													</div>
												) : !isEmpty(userDetails?.userName) && apiPermission.includes(val.apiPermission) ? (
													<div key={i} className="serviceCard center" onClick={() => navigate(val.link, { state: val })}>
														<div>
															{typeof iconMap[val.icon] === 'string' ? <img src={bbpsLogo} alt={'bbpsLogo'} /> : iconMap?.[val.icon]}

															<h3>{val.title}</h3>
														</div>
													</div>
												) : (
													''
												);
											})}
									</div>
								</div>
							</ServiceBoxWrapper>
						</>
					</Wrapper>
				</div>
			</div>
			<AboutPay2Mobile />
			<FooterContent />
			<GrowYourBussion />
			<DownloadPay2Mobile />
		</>
	);
};

export default ServiceList;
